import { type DesktopAppPlatform } from '@frameio/utils/browser';
import {
  DRIVE_APP_DOWNLOAD_URLS,
  TRANSFER_APP_DOWNLOAD_URLS,
} from '../../operations/constants';
import TEXT from './generated/TEXT/GetDriveDownloadUrl';

TEXT.DEFINE({
  /** CTA to download for macOS */
  downloadMac: 'Get macOS app',
  /** CTA to download for Windows */
  downloadWindows: 'Get Windows app',
});

type DownloadOption = {
  key: 'mac-arm' | 'mac-x64' | 'windows';
  label: string;
  link: string;
};

const DRIVE_OPTIONS: DownloadOption[] = [
  {
    key: 'mac-arm',
    label: TEXT.downloadMac,
    link: DRIVE_APP_DOWNLOAD_URLS.macArm,
  },
  {
    key: 'windows',
    label: TEXT.downloadWindows,
    link: DRIVE_APP_DOWNLOAD_URLS.windows,
  },
  {
    key: 'mac-x64',
    label: TEXT.downloadMac,
    link: DRIVE_APP_DOWNLOAD_URLS.macX64,
  },
];

const TRANSFER_OPTIONS: DownloadOption[] = [
  {
    key: 'mac-arm',
    label: TEXT.downloadMac,
    link: TRANSFER_APP_DOWNLOAD_URLS.mac,
  },
  {
    key: 'windows',
    label: TEXT.downloadWindows,
    link: DRIVE_APP_DOWNLOAD_URLS.windows,
  },
  {
    key: 'mac-x64',
    label: TEXT.downloadMac,
    link: TRANSFER_APP_DOWNLOAD_URLS.mac,
  },
];

/**
 * Returns the download options ordered so the detected platform comes first,
 * followed by the remaining options.
 */
export function getDriveDownloadOption(
  detectedPlatform: DesktopAppPlatform,
  app?: 'transfer' | 'drive'
): DownloadOption {
  const options = app === 'transfer' ? TRANSFER_OPTIONS : DRIVE_OPTIONS;
  return detectedPlatform
    ? options.find((o) => o.key === detectedPlatform) ?? options[0]
    : options[0];
}
